import axios from "axios";
//const apiurl = "http://hzc.hrbcft.com/api/"; //全局接口
//const imgurl = "http://hzc.hrbcft.com/"
//const apiurl = "http://197.77.77.203:8022/api/"; //全局接口
//const imgurl = "http://197.77.77.203:8022/"
const apiurl = "http://123.56.153.64:8001/api/"; //全局接口
const imgurl = "http://123.56.153.64:8001/"

//导出exo
const dowex = (params = {}, url = '', name = '') => {
    const that = this;
    params.admin_token = localStorage.getItem("admin_token")
    const link = document.createElement('a')
    var httpurl = apiurl + url
    axios.post(httpurl, params, {
        responseType: 'arraybuffer',
        headers: {
        }
    }).then(res => {
        var enc = new TextDecoder('utf-8')
        try {
            var resa = JSON.parse(enc.decode(new Uint8Array(res.data))) //转化成json对象

        } catch (err) {
            // 	// 创建Blob对象，设置文件类型
            let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel"
            })
            let objectUrl = URL.createObjectURL(blob) // 创建URL
            link.href = objectUrl
            link.download = name || '文件' // 自定义文件名
            link.click() // 下载文件
            URL.revokeObjectURL(objectUrl); // 释放内存
        }
    })
}




export default {
    apiurl,
	imgurl
    , dowex
}


